import { SocialTaskBonus } from 'config/types/bonus/socialTaskBonus'
import { useRequest } from 'hooks/useRequest'
import { useEffect, useMemo } from 'react'
import BonusService from 'services/BonusService'
import { useAppDispatch, useAppSelector } from 'state'
import { useAuth } from 'state/auth/hooks'
import { updateSocialTaskBonuses } from '../actions'

export const useSocialTaskBonuses = (): SocialTaskBonus[] => {
  const socialTaskBonuses = useAppSelector((state) => state.bonus.socialTaskBonuses)
  return useMemo(() => socialTaskBonuses, [socialTaskBonuses])
}

export const useInitializeSocialTaskBonuses = () => {
  const dispatch = useAppDispatch()
  const { isSigned } = useAuth()
  const { execute } = useRequest()

  useEffect(() => {
    if (isSigned) {
      const fetch = async () => {
        const response = await execute(BonusService.getUserSocialTaskBonusList())
        if (response.data?.length) dispatch(updateSocialTaskBonuses({ bonuses: response.data }))
      }

      fetch()
    }
  }, [isSigned])
}
